import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import parse from 'html-react-parser';

import {Button} from '../Button';
import {CloseButton} from '@learningblocks/storybook-components';
import { SolutionTube } from '@learningblocks/storybook-components';
import { HighlightHTML } from "@learningblocks/storybook-components";

import Fail from './img/Fail.svg';
import Pass from './img/Pass.svg';

const OPTION_ID = 'optionID';

export function ReagentItem(props){

  const onClick = (event) => {
    event.preventDefault();
    props.setAsNextStep(props.id);
  };

  const getImage = (component, type, solutionProps) => {
    return (
      <div className={"graphics" + " " + component} style={{textAlign: "center"}}>
        <SolutionTube
          isOpen={false}
          size={'md'}
          type={type}
          toggleOpen={() => {}}
          solution={
            {
              solutionColor: solutionProps.solutionColor,
              label: solutionProps.label,
              isOpen: false
            }
          }
        />
      </div>
    )
  }

  return(
    <li tabIndex={0} className={((props.selected)?'selected':null)} onClick={()=>((!props.selected)?props.addControlItem(props.id):props.removeControlItem(props.id))} style={{cursor: 'pointer'}} aria-label={props.solutionProps.altText}>
      <div className="moveButton">
        {((props.selected)?(
          <img src={Pass} alt="" style={{
            width: "100%",
            margin: 0
          }}/>
        ):null)}
      </div>
      {getImage("solution", props.type, props.solutionProps)}
      <p tabIndex={0}>{parse(props.fullName)}</p>
    </li>
  )
}
ReagentItem.propTypes = {
  type: PropTypes.string,
  selected: PropTypes.boolean,
  id: PropTypes.string,
  addControlItem: PropTypes.function
};

export function ReagentSelect(props) {

  const [controlContents, setControlContents] = useState([]);
  useEffect(()=>{
    setSubmitted(false)
  }, [controlContents])
  const [submitted, setSubmitted] = useState(false);

  const removeControlItem = (itemID) => {
    setControlContents(controlContents.filter((x)=>{
      return x !== itemID
    }));
  }

  const addControlItem = (itemID) => {
    if(!controlContents.includes(itemID)){
      setControlContents([...controlContents, itemID]);
    }
  }

  const getFeedback = (controlContents) => {
    let response = "";
    let correct = false;

    if(controlContents.includes(2)){
      //If they include Restriction enzyme
      response = "Oops, you have included <i>Hae</i>III restriction enzyme. Restriction enzymes cleave (break down) DNA and could cleave our PCR products if we include them in the reaction. We will use restriction enzymes after the PCR to analyze our PCR products. Why don't you try again?"
    } else if(controlContents.includes(8)){
      //If they include GENE Y template DNA
      response = "Not quite. You have included template DNA that includes <i>GENE Y</i> instead of the template that includes <i>GENE X</i>. This template will not be copied by primers that are specific for <i>GENE X</i>. What combination of template and primers will result in PCR amplification?"
    } else if(
      !controlContents.includes(1) ||
      !controlContents.includes(3) ||
      !controlContents.includes(4) ||
      !controlContents.includes(5) ||
      !controlContents.includes(6) ||
      !controlContents.includes(7)
    ){
      // If they are missing any of the required ingredients
      response = "Close, but is there anything else we need to include for PCR to occur?"
    } else {
      correct = true;
      // dNTPs, Taq DNA polymerase, Forward primer for GENE X, Reverse primer for GENE X, Buffer, GENE X template DNA
      response = "Excellent! A PCR requires the following components: dNTPs, reaction buffer, template DNA, <i>Taq</i> DNA polymerase, and forward and reverse primers that match the template DNA."
    }

    return (
      <div className={(correct)?"correct":"incorrect"} style={{
        display: "flex",
        flexDirection: "row",
        height: "auto",
        border: ((correct)?"1px solid #84be60":"1px solid #ed3431"),
        borderRadius: "5px",
        marginTop: "8px"
      }}>
        <div style={{
          background: ((correct)?"#84be60":"#ed3431"),
          width: "60px",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: "0 0 60px",
        }}>
          <img src={(correct)?Pass:Fail} alt="" style={{
            width: "100%"
          }}/>
        </div>
        <p style={{padding: "8px", margin: 0}}>{parse(response)}</p>
      </div>
    );
  }

  return(
    <div className={props.className}>
      <p style={{
        margin: "0 0 4px 0",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "uppercase"
      }}>Reagent select</p>
      <p style={{marginTop: 0, whiteSpace: 'pre-wrap'}} tabIndex={0}>
        <HighlightHTML
          content={props.text}
          getContentData={props.getGlossaryItem}
          openGlossary={props.onOpenGlossary}
        />
      </p>
      <div className="selectWrapper" aria-label={props.altText}>
        <div className="reagentsList">
          <ul>
            {props.select.map((item, index)=>(
              <ReagentItem
                id={item.props.id}
                type={item.props.type}
                fullName={item.props.fullName}
                addControlItem={addControlItem}
                removeControlItem={removeControlItem}
                selected={controlContents.includes(item.props.id)}
                solutionProps={item.props}
              />
            ))}
          </ul>
        </div>
        <div className="reagentDropZone">
          <div style={{width: "135px", padding: "8px", borderRight: "1px solid white"}}>
          <div className="graphics solution" style={{textAlign: "center"}} aria-label={props.dropZoneAltText}>
            <SolutionTube
              isOpen={false}
              size={'lg'}
              type={'Control'}
              toggleOpen={() => {}}
              solution={
                {
                  label: parse("H<tspan dy='3'>2</tspan><tspan dy='-3'>O</tspan>"),
                  isOpen: false
                }
              }
            />
          </div>
          <p>Positive control tube</p>
          </div>
          <div style={{width: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", padding: "8px"}}>
              <h5 style={{color: "white", fontWeight: "normal"}}>Contents (in DNase-free water)</h5>
              {/*<p style={{margin: "0 0 0 auto"}}>{"Select: " + props.answer.length}</p>*/}
            </div>
            <ul style={{listStyle: "none", padding: "0 4px", margin: "0 0 8px 0"}}>
              {controlContents.map((item, index)=>(
                <li
                  style={{
                    padding: "8px",
                    background: "#E5ECF0",
                    border: "1px solid #99B2C4",
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    marginTop: "4px",
                    fontSize: "14px",
                    color: "#003E6B"
                  }}>
                  <div style={{position: 'relative'}}>
                    <CloseButton close={(e)=>removeControlItem(item)} className={"remove-reagent"} />
                  </div>
                  {parse(props.select[props.select.findIndex((x) => (x.props.id === item))].props.fullName)}
                  </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="feedbackWrapper">
        {
          (submitted)?getFeedback(controlContents):null
        }
      </div>
      <div style={{display: "flex", marginTop: "16px", flexDirection: "row"}}>
        <p style={{marginRight: "auto", lineHeight: "28px"}}>Attempts left: Unlimited</p>
        <Button disabled={submitted} className='submitReagents' onClick={(e)=>setSubmitted(true)}>
          Submit
        </Button>
      </div>
    </div>
  )

}
ReagentSelect.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  select: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ReagentSelect.defaultProps = {
  className: 'reagentDragDrop',
};
